import { render, staticRenderFns } from "./VrGuide.vue?vue&type=template&id=b01aa094&scoped=true"
import script from "./VrGuide.vue?vue&type=script&lang=js"
export * from "./VrGuide.vue?vue&type=script&lang=js"
import style0 from "./VrGuide.vue?vue&type=style&index=0&id=b01aa094&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b01aa094",
  null
  
)

export default component.exports